// device dependant functions
// caveats:


/**
 * device dependant functions
 * ==========================
 *
 * caveats:
 *         1. camera rotation retrieval is different desktop/cardboard vs oculus
 *         2. oculus has camera height, other devices have camera height zero. (google-cb and desktop has no camera position)
 *
 */

const userAgent = window.navigator.userAgent;
const isFirefoxReality = userAgent.includes('Mobile VR');

const getCameraPosition = function () {
    const scene = document.querySelector('a-scene');
    if (!scene) return new THREE.Vector3();
    const camera = scene.camera;
    if (!camera) return new THREE.Vector3();

    const cameraPosition = new THREE.Vector3();
    cameraPosition.setFromMatrixPosition(camera.matrixWorld);

    return cameraPosition;
}

const getCameraRotation = function () {
    const scene = document.querySelector('a-scene');
    if (!scene) return new THREE.Vector3();
    const camera = scene.camera;
    if (!camera) return new THREE.Vector3();

    const cameraRotation = new THREE.Quaternion();
    cameraRotation.setFromRotationMatrix(camera.matrixWorld);

    return cameraRotation;
}

const formatPosition = function (position) {
    return position.x.toLocaleString('en-US',{minimumFractionDigits: 2, maximumFractionDigits: 2})
    + ' ; ' + position.y.toLocaleString('en-US',{minimumFractionDigits: 2, maximumFractionDigits: 2})
    + ' ; ' + position.z.toLocaleString('en-US',{minimumFractionDigits: 2, maximumFractionDigits: 2});
}

export {
    userAgent,
    isFirefoxReality,
    getCameraPosition,
    getCameraRotation,
    formatPosition
};